import * as Yup from 'yup'

export const BoardCrewSortSchema = Yup.array().of(Yup.object().shape({
    id: Yup.number().required(),
    crew_id: Yup.number().required(),
    name: Yup.string().required(),
    subdivision: Yup.string().required(),
    sort_order: Yup.number().required(),
    is_active: Yup.boolean().required(),
    is_subcontractor: Yup.boolean().required()
}))